import {combineReducers, type Reducer, type Store, type ReducersMapObject} from 'redux';

import {type Entity} from 'web-app/react/entities/factory/index';
import {type Action} from 'web-app/util/redux/action-types';

import {StoreKey} from './constants';

let savedReducers: ReducersMapObject<any, Action<any>> = {};

/**
 * Swaps the current mainReducer with a reducer that includes the given reducer under the "entityFactory" key
 * @param reducer
 * @param domain
 */
const addReducer = <StateType>(
    store: Store<StateType, Action<any>>,
    reducersObj: ReducersMapObject<any, Action<any>>,
    reducer: Reducer<any, Action<any>>,
    domain: string,
) => {
    savedReducers = {
        ...savedReducers,
        [domain]: reducer,
    };

    const factoryReducer = combineReducers(savedReducers);

    const newMainReducer = combineReducers<any, Action<any>>({
        ...reducersObj,
        [StoreKey]: factoryReducer,
    });

    store.replaceReducer(newMainReducer as Reducer<StateType, Action<any>>);
};

const initialize = <StateType>(
    store: Store<StateType, Action<any>>,
    reducersObj: ReducersMapObject<any, Action<any>>,
    entity: Entity<StateType, any, any>,
) => {
    addReducer<StateType>(store, reducersObj, entity.reducer, entity.domain);
};

export default initialize;
